import Skeleton from 'react-loading-skeleton';
import React from 'react';

const Page = React.lazy(()=>import('./SponsorChooser'))

export default function LazySponsorChooser(props){
    return <React.Suspense fallback={<Skeleton height={36.5} />}>
        <Page {...props} />
    </React.Suspense>
}
